import React, { Fragment } from "react";
import moment from "moment";

export function seatsLeftEvaluator(seatsLeft) {
  if (seatsLeft > 1 && seatsLeft < 10) {
    return ` ${seatsLeft} spots left!`;
  }
  if (seatsLeft === 1) {
    return " Hurry, only 1 spot left!";
  }
  if (seatsLeft <= 0) {
    return (
      <Fragment>
        {" "}
        No spots left!&nbsp;
        <a
          className="success"
          href="https://www.givevolunteers.org/contact/"
          rel="noopener noreferrer"
          target="_blank"
        >
          Contact GIVE
        </a>
      </Fragment>
    );
  }

  return "";
}

export function formatDate(startDate, endDate) {
  if (startDate && endDate) {
    const startDateArr = moment(startDate)
      .format("MMMM Do, YYYY")
      .split(" ");
    const endDateArr = moment(endDate)
      .format("MMMM Do, YYYY")
      .split(" ");

    if (startDateArr[2] === endDateArr[2]) {
      startDateArr.pop();
      startDateArr[1] = startDateArr[1].replace(/,/g, "");
    }
    if (startDateArr[0] === endDateArr[0]) {
      endDateArr.shift();
    }
    return `${startDateArr.join(" ")} - ${endDateArr.join(" ")}`;
  } else {
    return "";
  }
}

export function formatTripName(name, startDate, endDate) {
  const nameArr = name.split(" ");
  let tripName = name;

  let month;

  for (let i = 0; i < nameArr.length; i += 1) {
    if (
      nameArr[i] === "January" ||
      nameArr[i] === "February" ||
      nameArr[i] === "March" ||
      nameArr[i] === "April" ||
      nameArr[i] === "May" ||
      nameArr[i] === "June" ||
      nameArr[i] === "July" ||
      nameArr[i] === "August" ||
      nameArr[i] === "September" ||
      nameArr[i] === "October" ||
      nameArr[i] === "November" ||
      nameArr[i] === "December"
    ) {
      month = nameArr[i];
      break;
    }
  }

  if (month) {
    nameArr.splice(nameArr.indexOf(month), nameArr.length - 1);
    tripName = nameArr.join(" ");
  }

  return `${tripName} ${formatDate(startDate, endDate)}`;
}

// TODO: This funciton should be changed and simplified once the logic for changing the structure of opportunities is complete (i.e. opportunity with a bunch of add-ons rather than packages in Salesforce)
export function formatPackageTitle(destination, addOns) {
  // Initialize variables
  let packageName = destination;

  if (!packageName.includes("Package")) {
    for (var i = 0; i < addOns.length; i++) {
      if (!addOns[i].name.includes("Academic")) {
        packageName += " & " + addOns[i].name.replace("Add-On", "");
      }
    }
  }

  return packageName;
}

// In theory, this function can be depricated once this logic is implemented on the Salesforce side and is sent with the Opportunity.
export function getActualStartDate(tripStartDate, addOns) {
  var actualStartDate = moment(tripStartDate);

  for (const [index] of addOns.entries()) {
    if (!addOns[index].name.includes("UNIV") && addOns[index].addOnStartDate) {
      if (actualStartDate.isAfter(moment(addOns[index].addOnStartDate))) {
        actualStartDate = moment(addOns[index].addOnStartDate);
      }
    }
  }
  return actualStartDate;
}

// In theory, this function can be depricated once this logic is implemented on the Salesforce side and is sent with the Opportunity.
export function getActualEndDate(tripEndDate, addOns) {
  var actualEndDate = moment(tripEndDate);

  for (const [index] of addOns.entries()) {
    if (!addOns[index].name.includes("UNIV") && addOns[index].addOnEndDate) {
      if (moment(addOns[index].addOnEndDate).isAfter(actualEndDate)) {
        actualEndDate = moment(addOns[index].addOnEndDate);
      }
    }
  }

  return actualEndDate;
}
